import "./Challenges.css"
const Jigsaw = () => {
    return (
        <div className="jigsaw">
            <div className="jigsaw-piece"></div>
            <div className="jigsaw-piece"></div>
            <div className="jigsaw-piece"></div>
            <div className="jigsaw-piece"></div>
            <div className="jigsaw-piece"></div>
            <div className="jigsaw-piece"></div>
            <div className="jigsaw-piece"></div>
            <div className="jigsaw-piece"></div>
            <div className="jigsaw-piece"></div>
            <div className="jigsaw-piece"></div>
            <div className="jigsaw-piece"></div>
            <div className="jigsaw-piece"></div>
        </div>
    )
}
export default Jigsaw; 